import React, { useRef } from 'react';
import { ExportDropdown } from "../../ExportDropdown";
import '../graphStyles.scss'
import { GraphDropDown } from '../GraphDropDown'
import { Row, Col } from 'react-bootstrap'
import NoDataFound from "../../NoDataFound"
import DateRangeFilter from "../DateRangeFilter/DateRangeFilter";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  Filler,
  BarController
)

const InfoIcon = ({ tooltipText }) => (
  <span className="info-tooltip-container">
    <svg className="info-tooltip-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
    <span className="info-tooltip-bubble">{tooltipText}</span>
  </span>
);




export function VisitorEngagementAndAddToCartGraph({ display, weeks, percentVisitors, percentBooking, percentBuying, nameLabels }) {
  const mainChartRef = useRef(null);
  const chartRef1 = useRef(null);
  const chartRef2 = useRef(null);
  const chartRef3 = useRef(null);
  const chartRef4 = useRef(null);

  const mergedChartRef = {
    get current() {
      if (display === "dashboard" && chartRef1.current && chartRef2.current && chartRef3.current && chartRef4.current) {
        const canvas1 = chartRef1.current.canvas;
        const canvas2 = chartRef2.current.canvas;
        const canvas3 = chartRef3.current.canvas;
        const canvas4 = chartRef4.current.canvas;

        const w = canvas1.width;
        const h = canvas1.height;
        const headerHeight = 40;

        const mergedCanvas = document.createElement('canvas');
        mergedCanvas.width = 2 * w;
        mergedCanvas.height = 2 * h + 2 * headerHeight;

        const ctx = mergedCanvas.getContext('2d');
        // Transparent background by default to match other graph exports

        // Set font style for week labels
        ctx.font = "bold 16px Arial";
        ctx.fillStyle = "#374151";

        // Draw week titles
        if (fWeeks && fWeeks.length >= 4) {
          ctx.fillText(`Week of ${fWeeks[0]}`, 20, 26);
          ctx.fillText(`Week of ${fWeeks[1]}`, w + 20, 26);
          ctx.fillText(`Week of ${fWeeks[2]}`, 20, h + headerHeight + 26);
          ctx.fillText(`Week of ${fWeeks[3]}`, w + 20, h + headerHeight + 26);
        }

        // Draw charts in 2x2 layout with offsets
        ctx.drawImage(canvas1, 0, headerHeight);
        ctx.drawImage(canvas2, w, headerHeight);
        ctx.drawImage(canvas3, 0, h + 2 * headerHeight);
        ctx.drawImage(canvas4, w, h + 2 * headerHeight);

        return { canvas: mergedCanvas };
      }
      return mainChartRef.current;
    }
  };

  const downloadGraph = (ref, fileName) => {
    if (ref && ref.current) {
      const canvas = ref.current.canvas;
      const url = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.download = fileName;
      link.href = url;
      link.click();
    }
  };

  const [currentWeek, setCurrentWeek] = React.useState(0)
  const [filteredIndices, setFilteredIndices] = React.useState(null)

  const onFilterChange = React.useCallback(({ filteredIndices: indices }) => {
    setFilteredIndices(indices);
  }, []);

  // Apply date range filter to the week-indexed arrays
  const fWeeks = filteredIndices ? filteredIndices.map(i => weeks[i]).filter(Boolean) : weeks;
  const fPercentVisitors = filteredIndices ? filteredIndices.map(i => percentVisitors[i]).filter(v => v !== undefined) : percentVisitors;
  const fPercentBooking = filteredIndices ? filteredIndices.map(i => percentBooking[i]).filter(v => v !== undefined) : percentBooking;
  const fPercentBuying = filteredIndices ? filteredIndices.map(i => percentBuying[i]).filter(v => v !== undefined) : percentBuying;
  const fNameLabels = filteredIndices ? filteredIndices.map(i => nameLabels[i]).filter(v => v !== undefined) : nameLabels;

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        display: display === 'dashboard' ? false : true,
        labels: {
          font: {
            size: function () {
              if (display !== 'dashboard' && window.innerWidth < 830) {
                return 9
              }
              else if (window.innerWidth < 830 & window.innerWidth > 570) {
                return 9
              } else {
                return 13
              }
            },
          },
          filter: (l) => (l.text !== 'none')
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart2").style.cursor = 'pointer';
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart2").style.cursor = 'default';
        },
      },
    },

    scales: {
      x: {
        title: {
          text: "Number of Sessions",
          display: display === 'dashboard' ? false : true,
          font: {
            size: function () {
              if (display !== 'dashboard' && window.innerWidth < 830) {
                return 10
              }
              else if (window.innerWidth < 830 & window.innerWidth > 570) {
                return 10
              } else {
                return 13
              }
            },

          },
        },
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: function () {
              if (display !== 'dashboard' && window.innerWidth < 830) {
                return 9
              }
              else if (window.innerWidth < 750 & window.innerWidth > 570) {
                return 9
              } else {
                return 13
              }
            },

          },
        }
      },
      y: {
        position: 'left',
        title: {
          text: "% of Visitors",
          display: display === 'dashboard' ? false : true,
          font: {
            size: function () {
              if (display !== 'dashboard' && window.innerWidth < 830) {
                return 10
              }
              else if (window.innerWidth < 750 & window.innerWidth > 570) {
                return 10
              } else {
                return 13
              }
            },

          },
        },
        ticks: {
          font: {
            size: function () {
              if (display !== 'dashboard' && window.innerWidth < 830) {
                return 9
              }
              else if (window.innerWidth < 830 & window.innerWidth > 570) {
                return 9
              } else {
                return 13
              }
            },
          },
        }
      },

      y1: {
        position: 'right',
        title: {
          text: "% of Visitors",
          display: display === 'dashboard' ? false : true,
          font: {
            size: function () {
              if (display !== 'dashboard' && window.innerWidth < 830) {
                return 10
              }
              else if (window.innerWidth < 830 & window.innerWidth > 570) {
                return 10
              } else {
                return 13
              }
            },
          },
        },
        ticks: {
          font: {
            size: function () {
              if (display !== 'dashboard' && window.innerWidth < 830) {
                return 9
              }
              else if (window.innerWidth < 830 & window.innerWidth > 570) {
                return 9
              } else {
                return 13
              }
            },
          },
        }
      }
    }
  }


  const labels = fNameLabels[currentWeek]

  const data = {
    labels,
    datasets: [
      {
        label: fPercentBuying[currentWeek] === undefined ? 'none' : (fPercentBuying[currentWeek].length !== 1 ? '% of Visitors Buying in this Cohort' : 'none'),

        data: fPercentBuying[currentWeek],
        type: 'line',
        fill: true,
        borderWidth: 3,
        yAxisID: 'y1',
        order: 2,
        pointRadius: 3,
        borderColor: fPercentBuying[currentWeek] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[currentWeek].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
        backgroundColor: fPercentBuying[currentWeek] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[currentWeek].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
        hoverBackgroundColor: fPercentBuying[currentWeek] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[currentWeek].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
      },
      {
        label: '% of Visitors Booking in this Cohort',

        data: fPercentBooking[currentWeek],
        yAxisID: 'y1',
        borderColor: 'rgba(0, 50, 248, 0.83)',
        backgroundColor: 'rgba(0, 50, 248, 0.83)',
        hoverBackgroundColor: 'rgba(0, 50, 248, 0.83)',
        order: 0,
        type: 'line',
        pointRadius: 3,
      },
      {
        label: '% of Visitors',

        data: fPercentVisitors[currentWeek],
        backgroundColor: 'rgba(150, 167, 200, 0.99)',
        hoverBackgroundColor: 'rgba(150, 167, 200, 0.99)',
        yAxisID: 'y',
        order: 1,
      },
    ],
  }



  /**
   * Hard coded data values for the 4 graphs on dashboard page to always
   * display the 4 most recent weeks
   */
  const dataOne = {
    labels,
    datasets: [
      {
        data: fPercentBuying[0],
        type: 'line',
        fill: true,
        borderWidth: 3,
        yAxisID: 'y1',
        order: 2,
        pointRadius: 3,
        borderColor: fPercentBuying[0] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[0].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
        backgroundColor: fPercentBuying[0] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[0].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
      },
      {
        label: '% of Visitors Booking in this Cohort',

        data: fPercentBooking[0],
        yAxisID: 'y1',
        borderColor: 'rgba(0, 50, 248, 0.83)',
        backgroundColor: 'rgba(0, 50, 248, 0.83)',
        order: 0,
        type: 'line',
        pointRadius: 3,
      },
      {
        label: '% of Visitors',

        data: fPercentVisitors[0],
        backgroundColor: 'rgba(150, 167, 200, 0.99)',
        yAxisID: 'y',
        order: 1,
      },
    ],
  }

  const dataTwo = {
    labels,
    datasets: [
      {
        data: fPercentBuying[1],
        type: 'line',
        fill: true,
        borderWidth: 3,
        yAxisID: 'y1',
        order: 2,
        pointRadius: 3,
        borderColor: fPercentBuying[1] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[1].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
        backgroundColor: fPercentBuying[1] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[1].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
      },
      {
        label: '% of Visitors Booking in this Cohort',

        data: fPercentBooking[1],
        yAxisID: 'y1',
        borderColor: 'rgba(0, 50, 248, 0.83)',
        backgroundColor: 'rgba(0, 50, 248, 0.83)',
        order: 0,
        type: 'line',
        pointRadius: 3,
      },
      {
        label: '% of Visitors',

        data: fPercentVisitors[1],
        backgroundColor: 'rgba(150, 167, 200, 0.99)',
        yAxisID: 'y',
        order: 1,
      },
    ],
  }

  const dataThree = {
    labels,
    datasets: [
      {
        data: fPercentBuying[2],
        type: 'line',
        fill: true,
        borderWidth: 3,
        yAxisID: 'y1',
        order: 2,
        pointRadius: 3,
        borderColor: fPercentBuying[2] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[2].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
        backgroundColor: fPercentBuying[2] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[2].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
      },
      {
        label: '% of Visitors Booking in this Cohort',

        data: fPercentBooking[2],
        yAxisID: 'y1',
        borderColor: 'rgba(0, 50, 248, 0.83)',
        backgroundColor: 'rgba(0, 50, 248, 0.83)',
        order: 0,
        type: 'line',
        pointRadius: 3,
      },
      {
        label: '% of Visitors',

        data: fPercentVisitors[2],
        backgroundColor: 'rgba(150, 167, 200, 0.99)',
        yAxisID: 'y',
        order: 1,
      },
    ],
  }



  const dataFour = {
    labels,
    datasets: [
      {
        data: fPercentBuying[3],
        type: 'line',
        fill: true,
        borderWidth: 3,
        yAxisID: 'y1',
        order: 2,
        pointRadius: 3,
        borderColor: fPercentBuying[3] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[3].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
        backgroundColor: fPercentBuying[3] === undefined ? 'rgba(0,0,0,0)' : (fPercentBuying[3].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
      },
      {
        label: '% of Visitors Booking in this Cohort',

        data: fPercentBooking[3],
        yAxisID: 'y1',
        borderColor: 'rgba(0, 50, 248, 0.83)',
        backgroundColor: 'rgba(0, 50, 248, 0.83)',
        order: 0,
        type: 'line',
        pointRadius: 3,
      },
      {
        label: '% of Visitors',

        data: fPercentVisitors[3],
        backgroundColor: 'rgba(150, 167, 200, 0.99)',
        yAxisID: 'y',
        order: 1,
      },
    ],
  }


  const allData = [
    ["Buying Percentage Data"],
    [`Week of ${fWeeks[0]}`, fPercentBuying[0]],
    [`Week of ${fWeeks[1]}`, fPercentBuying[1]],
    [`Week of ${fWeeks[2]}`, fPercentBuying[2]],
    [`Week of ${fWeeks[3]}`, fPercentBuying[3]],
    [],
    ["Booking Percentage Data"],
    [`Week of ${fWeeks[0]}`, fPercentBooking[0]],
    [`Week of ${fWeeks[1]}`, fPercentBooking[1]],
    [`Week of ${fWeeks[2]}`, fPercentBooking[2]],
    [`Week of ${fWeeks[3]}`, fPercentBooking[3]],
    [],
    ["Visitor Percentage Data"],
    [`Week of ${fWeeks[0]}`, fPercentVisitors[0]],
    [`Week of ${fWeeks[1]}`, fPercentVisitors[1]],
    [`Week of ${fWeeks[2]}`, fPercentVisitors[2]],
    [`Week of ${fWeeks[3]}`, fPercentVisitors[3]],
  ];

  return (
    <div className="graph">
      <div className="graph__title flex flex-col md:flex-row justify-between items-center">
        <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0 flex items-center gap-1.5 justify-center md:justify-start">
          <span>Visitor engagement and added to cart</span>
          <InfoIcon tooltipText="Provides a breakdown of buying, booking, and session-engagement percentages over recent weeks." />
        </h4>
        <div className="flex items-center gap-2 flex-wrap justify-end pr-3">
          <DateRangeFilter weeks={weeks} onFilterChange={onFilterChange} />
          <ExportDropdown
            data={allData}
            chartRef={mergedChartRef}
            name="Visitor Engagement & Add to Cart Data"
          />
          <GraphDropDown
            display={display}
            currentWeek={currentWeek}
            setCurrentWeek={setCurrentWeek}
            weeks={fWeeks}
            className="w-full md:w-auto"
          />
        </div>
      </div>

      {weeks.length === 0 ? (
        <NoDataFound />
      ) : (
        // Main dashboard display with 4 graphs in 2 by 2 grid
        <div>
          {display === "dashboard" ? (
            <>
              {/* Hidden main chart container for generating Excel/Image export on dashboard view */}
              <div style={{ position: 'absolute', left: '-9999px', top: '-9999px', width: '650px', height: '350px', pointerEvents: 'none' }}>
                <Chart
                  ref={mainChartRef}
                  className="chart"
                  id="chart2_hidden"
                  type="bar"
                  options={options}
                  data={data}
                />
              </div>
              <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="small__chart__container">
                  <div className="engagement__date">
                    <span>Week of {fWeeks[0]}</span>
                  </div>
                  <Chart
                    ref={chartRef1}
                    className="small__chart"
                    id="chart2"
                    type="bar"
                    options={options}
                    data={dataOne}
                  />
                </div>

                <div className="small__chart__container">
                  <div className="engagement__date">
                    <span>Week of {fWeeks[1]}</span>
                  </div>
                  <Chart
                    ref={chartRef2}
                    className="small__chart"
                    id="chart2"
                    type="bar"
                    options={options}
                    data={dataTwo}
                  />
                </div>

                <div className="small__chart__container">
                  <div className="engagement__date">
                    <span>Week of {fWeeks[2]}</span>
                  </div>
                  <Chart
                    ref={chartRef3}
                    className="small__chart"
                    id="chart2"
                    type="bar"
                    options={options}
                    data={dataThree}
                  />
                </div>

                <div className="small__chart__container">
                  <div className="engagement__date">
                    <span>Week of {fWeeks[3]}</span>
                  </div>
                  <Chart
                    ref={chartRef4}
                    className="small__chart"
                    id="chart2"
                    type="bar"
                    options={options}
                    data={dataFour}
                  />
                </div>
              </div>
            </>
          ) : (
            // Content performance page display
            <div className="content__engagement__container relative w-full h-64 md:h-96">
              <Chart
                ref={mainChartRef}
                className="chart content__engagement__chart"
                id="chart2"
                type="bar"
                options={options}
                data={data}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}